<template>
  <div>
    <div class="alert alert-danger" role="alert" v-if="showAlert">
      {{ alertText }}
    </div>
    <div class="row apply-row">
      <div
        class="
          col-12 col-md-6
          text-center
          d-flex
          flex-column
          justify-content-center
          align-items-center
          apply-left
        "
      >
        <div class="flex-fill"></div>
        <div class="apply-text flex-fill mb-lg-0 mb-4">
          如果您尚未登錄您的報名資料<br />
          請由此進入進行報名資料的登錄
        </div>
        <button class="btn apply-btn" @click="$router.push('/new-apply')">
          前往報名
        </button>
      </div>
      <div
        class="
          col-12 col-md-6
          text-center
          d-flex
          flex-column
          justify-content-center
          align-items-center
          apply-right
        "
      >
        <div class="apply-text">
          如果已經有報名資料<br />
          請由此進入修改您的報名資料
        </div>
        <div class="col-12">
          <input
            type="text"
            class="form-control w-100"
            placeholder="請輸入身分證字號"
            v-model="idno"
            required
          />
        </div>
        <div class="col-12">
          <input
            type="text"
            class="form-control w-100"
            placeholder="請輸入報名使用的 email"
            v-model="email"
            required
          />
        </div>
        <button class="btn apply-btn" @click="handleLogin">登入</button>
      </div>
    </div>
  </div>
</template>

<script>
import { applicantLogin } from '@/api/applicant';

export default {
  name: 'Apply',

  data() {
    return {
      showAlert: false,
      alertText: '',
      picked: null,
      group: null,
      email: '',
      idno: '',
      groupOption: {
        1: '數位動畫組',
        2: '視覺傳達設計組',
        3: '時尚設計組',
      },
      applyMethod: null,
      applyMethodOption: {
        1: '自行申請',
        2: '學校推薦',
        3: '新一代金點新秀獎',
      },
      sex: null,
      sexOption: {
        1: '男',
        2: '女',
      },
      schoolSystem: null,
      schoolSystemOption: {
        1: '大學',
        2: '研究所',
      },
    };
  },
  methods: {
    handleLogin() {
      if (this.email.trim().length === 0 || this.idno.trim().length === 0) {
        this.showAlert = true;
        this.alertText = '請輸入身分證字號及Email';
        return;
      }
      const filter = { where: { email: this.email, idno: this.idno } };
      applicantLogin({ filter })
        .then((response) => {
          if (response) {
            this.$router.push('/apply');
            // this.$store.commit('setApplicantInfo', response);
            localStorage.setItem('applicantInfo', JSON.stringify(response));
          } else {
            this.showAlert = true;
            this.alertText = '身分證字號或Email錯誤';
          }
        })
        .catch((err) => {
          this.showAlert = true;
          this.alertText = '身分證字號或Email錯誤';
          console.log(err);
        });
    },
  },
};

</script>

<style lang="stylus" scoped>
.apply-left
  padding-right: 10%;
  border-right: 1px solid $monoc4;

.apply-right
  padding-left: 10%;

.row>div
  margin-bottom: 30px;

.apply-text
  margin-bottom: 30px;

::placeholder, :-ms-input-placeholder, ::-ms-input-placeholder
  color: $monoc2;
  opacity: 1;
  font-size: 15px;
  line-height: 150%;

.apply-btn
  padding: 10px;
  background: $monoc4;
  border-radius: 100px;
  width: 160px;

  &, &:hover, &:focus, &:active
    color: $contract1;

@media screen and (max-width: 767.5px)
  .apply-left
    padding: 10%;
    border-right: none;
    border-bottom: 1px solid $monoc4;

  .apply-right
    padding: 10%;
</style>
<style lang="stylus">
.apply-row input.form-control
  padding: 10px 0 0;
  border: none;
  background: none;
  border-radius: 0;
  border-bottom: 1px solid #463F3A;
  margin-bottom: 30px;

  &:focus, &:hover, &:active
    box-shadow: none;
</style>
